import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { StaticConstantsProvider } from "../static-constants/static-constants";
import { AlertController } from 'ionic-angular';
import { environment } from './environment';

@Injectable()

export class ConnectorProvider {

    dataCatalogue: any;
    public alert: any;

    //connect left menu variable function
    invokeOnVariable = new EventEmitter(); 

    // ********** FROM conf.ini **********
    public app_name: string;
    public app_version: string = ''
    public logo: string;
    public toolbar_buttons: any
    public mapfilesdir: string
    public stations_mapfile: string
    public map_type: string
    public getfeature: boolean
    public select_max_fcst: boolean
    // **********************************

    constructor(
        public http: HttpClient,
        private consts: StaticConstantsProvider,
        public alertCtrl: AlertController) {
    }

    onMenuItemClick(selected) {    
        this.invokeOnVariable.emit(selected); 
    }  

    public getConfiguration() {
        return new Promise(resolve => {
            this.http.get(this.consts.configurationURL + "?ts=" + Date.now()).subscribe(data => {
                resolve(data);
            }, err => {
                console.log("ERROR in getConfiguration", err);
            });
        });
    }

    public getCatalogue() {
        // return new Promise(resolve => {
        //     this.http.get(this.consts.CatalogueBaseURL + "?ts=" + Date.now()).subscribe(data => {
        //         resolve(data);
        //     }, err => {
        //         console.log(err);
        //     });
        // });

        // Includere il mapfile dinamicamente, non in STATIC CONSTANTS come è ora!!!!!!!!!!!!!!!!!!!!!!!!!
        return new Promise(resolve => {
            this.http.get(this.consts.GetCapabilitiesURL + "&ts=" + Date.now(), 
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'text/xml') 
                .append('Access-Control-Allow-Methods', 'GET') 
                .append('Access-Control-Allow-Origin', '*')
                .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"), 
                responseType:'text'
            })
            .subscribe((data)=>
            {
                resolve(data);
            });
        });
    }

    public getDynData(layer: String, latmin: Number, latmax: Number, lonmin: Number, lonmax: Number, minPal: String, maxPal: String, customMinPal: Number, customMaxPal: Number, session: String, pdate: String) {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT');
        //let options = new RequestOptions({ headers: headers });
        let params = JSON.stringify({
            layer: layer,
            latmin: latmin,
            latmax: latmax,
            lonmin: lonmin,
            lonmax: lonmax,
            minPal: minPal,
            maxPal: maxPal,
            customMinPal: customMinPal,
            customMaxPal: customMaxPal,
            session: session,
            pdate: pdate
        });
        return new Promise(resolve => {
            this.http.post(this.consts.dynBaseURL, params, { headers: headers }).subscribe(data => {
                resolve(data);
            }, err => {
                console.log(err);
            });
        });
    }

    public getTimeserie(layer: any, height: Number, width: Number, i: Number, j: Number, lat: String, lon: String, bbox: any, timeseriesTimesteps: any) {
        return new Promise((resolve, reject) => {
            let url = 'https://medfs.cmcc.it/backend/getFeatureInfo/?' + 'layer=' + layer + '&height=' + height + '&width=' + width + '&i=' + i + '&j=' + j + '&lat=' + lat + '&lon=' + lon + '&bbox=' + bbox + '&timesteps=' + timeseriesTimesteps + '&ts=' + Date.now()
            if (layer.includes('In-situ-Torre-Guaceto')) url =  this.consts.configurationURL.replace('config.php', '') + '/support/cascade/torre-guaceto/?' + 'layer=' + layer;
            else if (layer.includes('In-situ-Arpa-FVG')) url =  this.consts.configurationURL.replace('config.php', '') + '/support/cascade/arpafvg/?' + 'layer=' + layer + '&lon=' + lon + '&lat=' + lat;

            this.http.get(url).subscribe(data => {
                resolve(data);
            }, err => {
                console.log(err);
                reject(false)
            });
        });
    }

    public getWMSTimeseries(layer: any, height: Number, width: Number, i: Number, j: Number, bbox: any, timeRange: any) {
        return new Promise((resolve, reject) => {
            // let url = environment.vhost_alias +'/backend/PALETTE/template/'+(layer.split(":")[0]).toLowerCase()+'/getFeatureInfo.php/?' + 'map=/srv/ov/backend/mapfiles/'+(layer.split(":")[0]).toLowerCase() + '-v2/APP.map&service=WMS&request=GetFeatureInfo&version=1.3.0' + '&crs=EPSG:3857' + '&QUERY_LAYERS=' + layer + '&layers='+ layer + '&height=' + height + '&width=' + width + '&i=' + i + '&j=' + j + '&bbox=' + bbox + '&TIME=' + timeRange + '&info_format=application/json'  + '&ts=' + Date.now()       
            let url = `${this.consts.getFeatureInfoURL}&crs=EPSG:3857&QUERY_LAYERS=${layer}&layers=${layer}&height=${height}&width=${width}&i=${i}&j=${j}&bbox=${bbox}&TIME=${timeRange}&info_format=application/json&ts=${Date.now()}`       
            console.log("WmsURL GFI: ", url)
            this.http.get(url).subscribe(data => {
                resolve(data);
            }, err => {
                console.log(err);
                reject(false)
            });
        });
    }

    public getRecordConfig(configUrl) {
        return this.http.get(configUrl);
    }

    public showAlert(title: string, subtitle: string): Promise<any> {
        this.alert = this.alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: [{ text: 'OK', role: 'cancel' }]
        });
        return this.alert.present();
    }

    public hideAlert() {
        this.alert.dismiss();
    }

    public getPNG(url) {
        return new Promise((resolve, reject) => {
            this.http.get(url, { responseType: 'blob' }).subscribe(data => {
                resolve(data);
            }, err => {
                console.log(err);
                reject(false)
            });
        });
    }

    public pngParser(buffer) {

        var view = new DataView(buffer),
            len = buffer.byteLength,
            magic1, magic2,
            chunks = [],
            size, fourCC, crc, offset,
            pos = 0;  // current offset in buffer ("file")

        // check header
        magic1 = view.getUint32(pos); pos += 4;
        magic2 = view.getUint32(pos); pos += 4;

        if (magic1 === 0x89504E47 && magic2 === 0x0D0A1A0A) {

            // parse chunks
            while (pos < len) {

                // chunk header
                size = view.getUint32(pos);
                fourCC = this.getFourCC(view.getUint32(pos + 4));

                // data offset
                offset = pos + 8;
                pos = offset + size;

                // crc
                crc = view.getUint32(pos);
                pos += 4;

                // store chunk
                chunks.push({
                    fourCC: fourCC,
                    size: size,
                    offset: offset,
                    crc: crc
                })
            }

            return { chunks: chunks }
        }
        else {
            return { error: "Not a PNG file." }
        }
    }

    private getFourCC(int) {
        var c = String.fromCharCode;
        return c(int >>> 24) + c(int >>> 16 & 0xff) + c(int >>> 8 & 0xff) + c(int & 0xff);
    }


}



// WEBPACK FOOTER //
// ./src/providers/connector/connector.ts